import React from 'react'
import Applicant from 'modules/react/loan-calculator/content/Applicant'
import { LoanCalculatorContext } from 'modules/react/loan-calculator/LoanCalculatorContainer'

export default function Applicants() {
  const { applicant } = React.useContext(LoanCalculatorContext)

  return (
    <div className='lc-applicants'>
      <Applicant applicant={applicant}/>
    </div>
  )
}
